import { Switch, SxProps, Theme } from '@mui/material'
import { MouseEventHandler, useEffect, useState } from 'react'
import { useApp } from '../../hooks/useApp'

export type CustomSwitchProps = {
  disabled?: boolean
  checked: boolean
  'data-cy'?: string
  onClick: () => void
  timeout?: number
  timeoutMessage?: string
  sx?: SxProps<Theme>
}

export const CustomSwitch = (props: CustomSwitchProps): React.ReactElement => {
  const { timeout, timeoutMessage, disabled, checked, sx } = props

  const [waiting, setWaiting] = useState(false)
  const [timer, setTimer] = useState<any>(null)
  const app = useApp()

  const onClick: MouseEventHandler<HTMLButtonElement> = (e) => {
    if (!waiting) {
      if (timeout) {
        setWaiting(true)
        setTimer(setTimeout(onTimeout, 1000 * timeout))
      }
      props.onClick && props.onClick()
    }
  }

  const onTimeout = () => {
    timeoutMessage && app.addError(timeoutMessage)
    setWaiting(false)
  }

  useEffect(() => {
    setWaiting(false)
    timer && clearTimeout(timer)
    setTimer(null)
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [timeout, props.checked])

  useEffect(() => {
    return () => {
      timer && clearTimeout(timer)
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return <Switch sx={{ ...sx }} data-cy={props['data-cy']} className={waiting ? 'waiting' : ''} disabled={disabled} checked={checked} onClick={onClick} />
}
